import React from "react";
import {
  FaCalendarAlt,
  FaClock,
  FaHome,
  FaTruck,
  FaArrowRight,
  FaCheckCircle,
  FaTimesCircle,
} from "react-icons/fa";

export default function GatepassCard({ gatePass, onClick }) {
  // Color scheme
  const eleghoBlue = "#363062";
  const eleghoGreen = "#8FCD00";

  // Function to format date
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString();
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "approved":
        return eleghoGreen;
      case "pending":
        return "#FFA500"; // Orange
      case "rejected":
        return "#FF0000"; // Red
      case "returned":
        return "#718096"; // Gray
      default:
        return "#808080"; // Default Gray
    }
  };

  const getStatusIcon = (status) => {
    switch (status?.toLowerCase()) {
      case "approved":
        return <FaCheckCircle />;
      case "pending":
        return <FaClock />;
      case "rejected":
        return <FaTimesCircle />;
      case "returned":
        return <FaArrowRight />;
      default:
        return <FaClock />;
    }
  };

  return (
    <div
      className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-hidden transition-all hover:shadow-md hover:translate-y-[-2px] cursor-pointer"
      onClick={() => onClick(gatePass.id, gatePass)}
    >
      <div className="p-4">
        <div className="flex justify-between items-start mb-2">
          <div className="text-sm font-medium text-[#363062]">
            {gatePass.requestedBy || "Unnamed Requestor"}
          </div>
          <div
            className="flex items-center px-2 py-1 rounded-full text-xs font-medium gap-1.5"
            style={{
              backgroundColor: `${getStatusColor(gatePass.status)}15`,
              color: getStatusColor(gatePass.status),
            }}
          >
            <span className="text-xs">{getStatusIcon(gatePass.status)}</span>
            {gatePass.status || "Unknown"}
          </div>
        </div>

        <div className="grid grid-cols-2 gap-2 text-xs text-gray-600 mb-3">
          <div className="flex items-center gap-1.5">
            <FaCalendarAlt className="text-gray-400 flex-shrink-0" />
            <span>{formatDate(gatePass.deliveryDate)}</span>
          </div>
          <div className="flex items-center gap-1.5">
            <FaClock className="text-gray-400 flex-shrink-0" />
            <span>{gatePass.deliveryTime || "N/A"}</span>
          </div>
          <div className="flex items-center gap-1.5">
            <FaHome className="text-gray-400 flex-shrink-0" />
            <span>{gatePass.identifier || "N/A"}</span>
          </div>
          <div className="flex items-center gap-1.5">
            <FaTruck className="text-gray-400 flex-shrink-0" />
            <span>{gatePass.deliveryCompany || "N/A"}</span>
          </div>
        </div>

        {/* Items Section */}
        {gatePass.items && (
          <div className="mt-2 pt-2 border-t border-gray-100">
            <div className="text-xs text-gray-500 mb-1.5">Items:</div>
            <div className="text-xs">
              <span className="w-1.5 h-1.5 rounded-full bg-[#363062] inline-block mr-1"></span>
              <span>{gatePass.items}</span>
            </div>
          </div>
        )}
      </div>
      {/* Footer with View Details */}
      <div className="flex justify-end items-center py-2 px-4 bg-gray-50 border-t border-gray-100">
        <div className="flex items-center text-xs font-medium text-[#363062]">
          View Details
          <FaArrowRight className="ml-1.5 w-3 h-3" />
        </div>
      </div>
    </div>
  );
}
